import getIn from 'immutable-less/transmute/getIn';
import * as AssociationActionTypes from 'automation-ui-associations/constants/AssociationActionTypes';
import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
import { ActionAssociationDefaults } from 'automation-ui-associations/constants/associationDefinitionsDefaults';
/**
 *
 * Grabs the object type ids that are associated by default with a new create task action
 * @param flowObjectTypeId
 * @returns array of flow object type ids
 */
export function getCreateTaskActionAssociationDefaults(flowObjectTypeId) {
  return getIn([AssociationActionTypes.TASK, flowObjectTypeId], ActionAssociationDefaults) || [];
}

/**
 *
 * Grabs the object type ids that are associated by default with new create object actions
 * @param flowObjectTypeId
 * @param createdObjectTypeId
 * @returns array of flow object type ids
 */
export function getCreateObjectActionAssociationDefaults(flowObjectTypeId, createdObjectTypeId) {
  if (createdObjectTypeId) {
    return getIn([AssociationActionTypes.CREATE_OBJECT, createdObjectTypeId, flowObjectTypeId], ActionAssociationDefaults) || [];
  }
  return [];
}

/**
 * NOTE
 * The following are replacement for util functions in HubSpotObjectAssocMap
 * to support custom objects and dynamic associations
 */

/**
 * Helper that converts association definitions into association spec records
 * @param id
 * @param category
 * @returns AssociationSpec | null depending on whether the param is correct.
 */
export const assocDefToSpec = ({
  id,
  category
}) => {
  if (!id || !category) {
    return null;
  }
  return new AssociationSpec({
    associationTypeId: id,
    associationCategory: category
  });
};